/** @format */
// 因为axios会把get请求的请求头的配置清除,在此创建一个新的axios实例,对get请求特殊处理
import axios from "axios";
import config from "./config";
const instance = axios.create(config);

const errorHandler = function() {
    // TODO 预留统一错误处理
    // const {
    //     head: { errCode },
    // } = err
    // switch (errCode) {
    //     case 4041003:
    //         break
    // }
};

function handleHttpInterceptors(instance) {
    // 错误处理函数
    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            errorHandler(error);
            return Promise.reject(error);
        }
    );

    instance.interceptors.request.use(
        (config) => {
            const POST_HEADERS = {
                "Content-Type": "application/json; charset=utf-8",
            };
            const { method, headers } = config;
            if (method === "get") config.data = { unused: 0 };

            return {
                ...config,
                headers: {
                    ...Object.assign(POST_HEADERS, headers),
                },
            };
        },
        (error) => Promise.error(error)
    );

    return instance;
}

export default handleHttpInterceptors(instance);